module.exports = __webpack_public_path__ + "static/media/lars_care.fb390d46.svg";